(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[736,346,8693],{

/***/ 98544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addClass; }
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),

/***/ 74277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ removeClass; }
/* harmony export */ });
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),

/***/ 82423:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest-experience",
      function () {
        return __webpack_require__(78452);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81057);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34495);
/* harmony import */ var _elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20027);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41197);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27895);






var StaffVertical = function(param) {
    var picture = param.picture, cloudflare_picture = param.cloudflare_picture, first_name = param.first_name, last_name = param.last_name, job = param.job, email = param.email, description = param.description, sizes = param.sizes, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_4__/* .withModifiers */ .i)("staff", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())),
        children: [
            picture && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__image),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LazyImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    alt: "Profile image-".concat(picture),
                    layout: "fill",
                    sizes: sizes,
                    src: cloudflare_picture ? (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(cloudflare_picture, "960") : (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_3__/* .getS3Url */ .v)(picture)
                })
            }, picture),
            (first_name || last_name) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__name),
                children: "".concat(first_name, " ").concat(last_name)
            }),
            job && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__occupation),
                children: job
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().staff__description),
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
                rel: "nofollow",
                href: "mailto:".concat(email),
                variant: [
                    "label",
                    "font-primary"
                ],
                children: [
                    "Email ",
                    first_name
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StaffVertical);


/***/ }),

/***/ 26189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74218);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73985);
/* harmony import */ var _Accordion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42192);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var AccordionGroup = function(param) {
    var items = param.items, _max = param.max, max = _max === void 0 ? 9999 : _max;
    if (items) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), openKey = ref[0], setOpenKey = ref[1];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().faqs),
            children: items.map(function(faq, index) {
                return index < max && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    classNames: "opacity",
                    appear: true,
                    timeout: {
                        enter: index * 150,
                        exit: index * 150
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Accordion__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        index: index,
                        openKey: openKey,
                        setOpenKey: setOpenKey,
                        variant: [
                            "large"
                        ],
                        title: faq.question,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: faq.answer
                            }
                        })
                    })
                }, index);
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionGroup);


/***/ }),

/***/ 90346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _layout_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70539);
/* harmony import */ var _layout_Columns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40050);
/* harmony import */ var _custom_Highlight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(958);
/* harmony import */ var _custom_Staff__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33528);
/* harmony import */ var _components_ContactForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64150);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61137);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40670);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34495);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79697);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(117);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);


















var Contact = function(param) {
    var title = param.title, description = param.description, _variant = param.variant, variant = _variant === void 0 ? [] : _variant, _buying = param.buying, buying = _buying === void 0 ? true : _buying, _separator = param.separator, separator = _separator === void 0 ? true : _separator, staff = param.staff, _leftLabel = param.leftLabel, leftLabel = _leftLabel === void 0 ? true : _leftLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sectionRef = param.sectionRef, route = param.route, translations = param.translations;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_8__/* .useResponsive */ .F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile;
    var isGeneral = variant.includes("general");
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (loaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            sectionRef: sectionRef,
            separator: separator,
            variant: [
                variant.includes("gray") ? "gray" : "white"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Columns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: [
                        isTablet ? "-align-center" : "-distribute-between"
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 7 : 6,
                            children: [
                                leftLabel && staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_14__/* .withModifiers */ .i)("intro", [
                                        isGeneral && "general",
                                        !leftLabel && "offset-top"
                                    ], (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default())),
                                    children: leftLabel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            " ",
                                            translations.interestedIn[router.locale],
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                variant: [
                                                    "accent",
                                                    "font-primary"
                                                ],
                                                children: translations.buying[router.locale]
                                            }),
                                            " ",
                                            translations.property[router.locale]
                                        ]
                                    }) : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: staff && !(0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(staff) && staff.map(function(person, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Staff__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                            width: isSmallMobile && 168,
                                            height: isSmallMobile && 308,
                                            variant: [
                                                "inline",
                                                "align-middle"
                                            ]
                                        }, person), {
                                            job: person.job[router.locale]
                                        }), "contact-staff-".concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            spans: isSmallMobile ? 12 : isTablet ? 11 : 6,
                            children: [
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().description),
                                    children: description
                                }),
                                isGeneral || title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
                                    children: title || translations.assistance[router.locale]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().intro), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().last)),
                                    children: [
                                        translations.interestedIn[router.locale],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_Highlight__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            variant: [
                                                "font-primary",
                                                buying && "accent"
                                            ],
                                            children: buying ? translations.buying[router.locale] : translations.renting[router.locale]
                                        }),
                                        translations.thisProperty[router.locale]
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ContactForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    route: route,
                                    translations: translations,
                                    disabled: disabled
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 7633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19511);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _elements_AccordionGroup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26189);








var FAQs = function(param) {
    var label = param.label, title = param.title, faqs = param.faqs, button = param.button;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(5), number = ref[0], setNumber = ref[1];
    if (faqs) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            variant: [
                "gray",
                "center"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                variant: [
                    "-xs3"
                ],
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().label),
                        children: label
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_AccordionGroup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        items: faqs,
                        max: number
                    }),
                    number < faqs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        appendIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_icons_icon_more_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                        variant: [
                            "color-primary"
                        ],
                        arrow: false,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button),
                        onClick: function() {
                            return setNumber(number + 5);
                        },
                        children: button
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 30124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24447);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51524);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(117);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36779);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _custom_StaffVertical__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35193);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);








var Professionals = function(param) {
    var label = param.label, title = param.title, staff = param.staff;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)(), isDesktop = ref.isDesktop, isSmallMobile = ref.isSmallMobile;
    if (staff && title) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Section__WEBPACK_IMPORTED_MODULE_1__["default"], {
            separator: true,
            variant: [
                "center",
                "separator-top"
            ],
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_2__["default"], {
                variant: [
                    isDesktop ? "-xs2" : "-xl2"
                ],
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                        children: label
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                        children: title
                    }),
                    staff && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: [
                                isSmallMobile ? "grid-1" : isDesktop ? "grid-2" : "grid-4",
                                "spacing-xl"
                            ],
                            children: staff.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_StaffVertical__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                    sizes: "(min-width: 1250px) 310px, (max-width: 1250px) 300vw, 70vw"
                                }, item), "staff-".concat(index));
                            })
                        })
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ __webpack_exports__["Z"] = (Professionals);


/***/ }),

/***/ 1962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30959);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34495);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27895);





var Perk = function(param) {
    var icon = param.icon, title = param.title, value = param.value, children = param.children, subtitle = param.subtitle, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_helpers_withModifiers__WEBPACK_IMPORTED_MODULE_3__/* .withModifiers */ .i)("perk", variant, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__icon),
                children: icon && typeof icon === "object" ? icon : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    width: 38,
                    height: 38,
                    alt: "icon ".concat(title),
                    src: (0,_helpers_getS3Url__WEBPACK_IMPORTED_MODULE_2__/* .getS3Url */ .v)(icon)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__title),
                        children: value
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: subtitle
                    }),
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().perk__description)
                    }),
                    children && children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Perk);


/***/ }),

/***/ 78452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ guest_experience; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/pages/guest-experience/Welcome/styles.module.scss
var styles_module = __webpack_require__(2104);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(73985);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/pages/guest-experience/Welcome/index.js









var CloudflareVideo = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69562)
            ];
        }
    },
    ssr: false
});
var Welcome = function(param) {
    var video = param.video, title = param.title, subtitle = param.subtitle, button = param.button;
    var ref = (0,react.useState)(false), play = ref[0], setPlay = ref[1];
    var ref1 = (0,react.useState)(false), minutes = ref1[0], setMinutes = ref1[1];
    var ref2 = (0,react.useState)(false), ready = ref2[0], setReady = ref2[1];
    var ref3 = (0,react.useState)(false), seconds = ref3[0], setSeconds = ref3[1];
    var ref4 = (0,react.useRef)(null);
    var onVideoLoaded = function() {
        var total = ref4.current.duration;
        var mins = Math.floor(total / 60);
        var secs = Math.floor(total - mins * 60);
        setMinutes(mins);
        setSeconds(secs);
        setReady(true);
    };
    (0,react.useEffect)(function() {
        play && ref4.current.play();
    }, [
        play
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        variant: [
            "center",
            "pb0"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).intro,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (styles_module_default()).intro__title,
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).intro__subtitle,
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).intro__video,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,withModifiers/* withModifiers */.i)("intro__mask", [
                                    ready && "hidden"
                                ], (styles_module_default()))
                            }),
                            video && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareVideo, {
                                controls: play,
                                playing: play,
                                src: video,
                                streamRef: ref4,
                                onCanPlay: onVideoLoaded
                            }),
                            button && !play && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                classNames: "opacity",
                                appear: true,
                                timeout: {
                                    enter: 200,
                                    exit: 200
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button["default"], {
                                    arrow: false,
                                    variant: [
                                        "primary-blue"
                                    ],
                                    onClick: function() {
                                        return setPlay(true);
                                    },
                                    className: (styles_module_default()).intro__trigger,
                                    children: [
                                        button,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "[".concat(minutes, ":").concat(seconds === 0 ? "00" : seconds, "]")
                                        })
                                    ]
                                })
                            }, play)
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var guest_experience_Welcome = (Welcome);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/pages/guest-experience/Summary/styles.module.scss
var Summary_styles_module = __webpack_require__(36794);
var Summary_styles_module_default = /*#__PURE__*/__webpack_require__.n(Summary_styles_module);
// EXTERNAL MODULE: ./components/pages/single-property/components/Perk/index.js
var Perk = __webpack_require__(1962);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./components/pages/guest-experience/Summary/index.js










// to be moved to a common component with welcome page
var Summary = function(param) {
    var statistics = param.statistics, label = param.label, title = param.title, description = param.description;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
        className: (Summary_styles_module_default()).section,
        variant: [
            "gray"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                variant: [
                    "-distribute-around",
                    "-align-middle"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                        spans: isMobile ? 12 : isTablet ? 7 : 6,
                        children: [
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Summary_styles_module_default()).label,
                                children: label
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: title
                                },
                                className: (Summary_styles_module_default()).title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Summary_styles_module_default()).description,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Summary_styles_module_default()).divider
                                    }),
                                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        spans: isMobile ? 12 : 5,
                        children: statistics && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Summary_styles_module_default()).perks,
                            children: statistics.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Perk/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    variant: [
                                        "large"
                                    ]
                                }, item), {
                                    icon: item.cloudflare_icon,
                                    title: item.title
                                }), index);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var guest_experience_Summary = (Summary);

// EXTERNAL MODULE: ./components/pages/guest-experience/Services/styles.module.scss
var Services_styles_module = __webpack_require__(66506);
var Services_styles_module_default = /*#__PURE__*/__webpack_require__.n(Services_styles_module);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
;// CONCATENATED MODULE: ./components/pages/guest-experience/Services/index.js









var Services = function(param) {
    var services = param.services;
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    if (services) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            variant: [
                "white",
                "pb0",
                "pt0"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                variant: [
                    "-xs"
                ],
                children: services.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Services_styles_module_default()).service,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Columns/* default */.Z, {
                            variant: [
                                index % 2 !== 0 && "reversed",
                                "-align-middle",
                                "-distribute-between"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                    spans: isSmallMobile ? 12 : 5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Services_styles_module_default()).service__image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                                            alt: "Image ".concat(item.title),
                                            layout: "fill",
                                            objectFit: "cover",
                                            objectPosition: "50%",
                                            src: (0,getS3Url/* getS3Url */.v)(item.cloudflare_picture || item.picture, "960")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                                    spans: isSmallMobile ? 12 : 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (Services_styles_module_default()).service__title,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: item.description
                                            },
                                            className: (Services_styles_module_default()).service__description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "service-".concat(index));
                })
            })
        });
    }
    return;
};
/* harmony default export */ var guest_experience_Services = (Services);

// EXTERNAL MODULE: ./components/pages/home/Reviews/index.js
var Reviews = __webpack_require__(35842);
// EXTERNAL MODULE: ./components/pages/common/Contact/index.js
var Contact = __webpack_require__(90346);
// EXTERNAL MODULE: ./components/pages/common/FAQs/index.js
var FAQs = __webpack_require__(7633);
// EXTERNAL MODULE: ./components/pages/common/Professionals/index.js
var Professionals = __webpack_require__(30124);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./pages/guest-experience/index.js












var GuestExperience = function(param) {
    var pageData = param.pageData, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, contactTranslation = param.contactTranslation, translations = param.translations;
    var ref = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation,
        footer: false,
        meta: {
            title: translations.seo.title[router.locale],
            description: translations.seo.description[router.locale]
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(guest_experience_Welcome, {
                title: translations.welcome.title[router.locale],
                subtitle: translations.welcome.subtitle[router.locale],
                button: translations.welcome.button[router.locale],
                video: pageData.cloudflare_video
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(guest_experience_Summary, {
                label: translations.summary.label[router.locale],
                title: translations.summary.title[router.locale],
                description: translations.summary.description[router.locale],
                statistics: pageData.statistics
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(guest_experience_Services, {
                services: pageData.service
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
                variant: [
                    "white",
                    "center"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews["default"], {
                    reviews: pageData.reviews,
                    sectionRef: ref
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Professionals/* default */.Z, {
                staff: pageData === null || pageData === void 0 ? void 0 : pageData.staff,
                label: translations.professionals.label[router.locale],
                title: translations.professionals.title[router.locale]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {
                label: translations.faqs.label[router.locale],
                title: translations.faqs.title[router.locale],
                button: translations.faqs.button[router.locale],
                faqs: pageData.faq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact["default"], {
                translations: contactTranslation,
                sectionRef: ref,
                title: translations.contact.title[router.locale],
                description: translations.contact.description[router.locale],
                staff: pageData.person,
                buying: false,
                separator: false,
                variant: [
                    "white"
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var guest_experience = (GuestExperience);


/***/ }),

/***/ 81057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"staff":"styles_staff__9uWL9","staff__image":"styles_staff__image__omVdv","staff__name":"styles_staff__name__rtWOB","staff__occupation":"styles_staff__occupation__FsJEM","staff__description":"styles_staff__description__FZpfS"};

/***/ }),

/***/ 74218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqs":"styles_faqs__LuqUI"};

/***/ }),

/***/ 61137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__R0Yt_","intro":"styles_intro__e1Is4","contact":"styles_contact___xZ2x","last":"styles_last__LjZl_","intro--general":"styles_intro--general__85IDi","intro--offset-top":"styles_intro--offset-top__l7dZT","title":"styles_title__HCVSt","description":"styles_description__T7k67","staff":"styles_staff__gQuG0","name":"styles_name__nWG3U","position":"styles_position__RkAOQ","label":"styles_label___1bq_","button":"styles_button__nXKqX","position--general":"styles_position--general__OycEg"};

/***/ }),

/***/ 19511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__yafgT","title":"styles_title__fUnLg","button":"styles_button__qbQt6"};

/***/ }),

/***/ 36779:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__NZY4O","title":"styles_title__JcQ8_","content":"styles_content__P_r8Y"};

/***/ }),

/***/ 66506:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"service":"styles_service__W4cWz","service__title":"styles_service__title__TLc7_","service__image":"styles_service__image__nW3d9","service__description":"styles_service__description__VhBLZ"};

/***/ }),

/***/ 36794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__M7b_5","title":"styles_title__mK7qM","label":"styles_label__Qn53p","divider":"styles_divider__jkeZ5","description":"styles_description__O0u1r","perks":"styles_perks__g4mLh"};

/***/ }),

/***/ 2104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro__title":"styles_intro__title__L3ja_","intro__subtitle":"styles_intro__subtitle__9TWFp","intro__trigger":"styles_intro__trigger__zq4Ux","intro__video":"styles_intro__video__CZmea","intro__mask":"styles_intro__mask__fKWJp","intro__mask--hidden":"styles_intro__mask--hidden__RJSog"};

/***/ }),

/***/ 30959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perk":"styles_perk__aYDiO","perk__icon":"styles_perk__icon__9_PGC","perk__title":"styles_perk__title__wwvP5","perk--spacing-xs":"styles_perk--spacing-xs__knH3y","perk--accent":"styles_perk--accent__GH2LI","perk__description":"styles_perk__description__uG0rQ","perk--title-color-dark":"styles_perk--title-color-dark__eY0DF","perk--style-inverted":"styles_perk--style-inverted__MCh15","perk--large":"styles_perk--large__OH1me"};

/***/ }),

/***/ 36378:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93589);
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27771);
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!(0,_isArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value) && (0,_isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) && (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["Z"] = (isString);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,7549,6820,8433,5798,3808,8094,3817,7713,8085,9774,945,2888,179], function() { return __webpack_exec__(82423); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);